import { useTranslation } from "@/src/i18n/client";
import { useCommonContext } from "@/src/provider";
import React from "react";

interface Props {}

const WarrantyTimeTips: React.FC<Props> = (props) => {
    const { site } = useCommonContext();
    const { t } = useTranslation("common");

    switch (site) {
        case "uk":
        case "us":
            return t("common:MONTH_WARRANTY_TIPS_6");
        default:
            return t("common:MONTH_WARRANTY_TIPS");
    }
};

export default WarrantyTimeTips;
